/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Thin_Fish_RideInputs */

const en_sage_thin_fish_ride = /** @type {(inputs: Sage_Thin_Fish_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove membership failed`)
};

const de_sage_thin_fish_ride = /** @type {(inputs: Sage_Thin_Fish_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Remove membership failed" |
*
* @param {Sage_Thin_Fish_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_thin_fish_ride = /** @type {((inputs?: Sage_Thin_Fish_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Thin_Fish_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_thin_fish_ride(inputs)
	return de_sage_thin_fish_ride(inputs)
});